import { render, staticRenderFns } from "./SchemeTextClassifyMenu.vue?vue&type=template&id=5a0779e2&scoped=true&"
import script from "./SchemeTextClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./SchemeTextClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextClassifyMenu.vue?vue&type=style&index=0&id=5a0779e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0779e2",
  null
  
)

export default component.exports